import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

function SingleLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      {...skeletonColors}
      height="64px"
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="64px" />
    </ContentLoader>
  );
}

export default function CardsLoader() {
  return (
    <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
      <SingleLoader />
      <SingleLoader />
      <SingleLoader />
    </div>
  );
}
